<template>
  <v-container>
    <page-heading>{{ pageTitle }}</page-heading>

    <div class="d-flex justify-end mb-2">
      <v-btn color="primary" @click="pushToRoute('ObjectGroupCreate')"><v-icon left>mdi-home-plus</v-icon>{{ trans('objectGroup.create') }}</v-btn>
      <v-btn @click="pushToRoute('ObjectGroupsSortPage')" class="ml-2"><v-icon left>mdi-sort-ascending</v-icon>{{ trans('objectGroup.sortObjectGroups') }}</v-btn>
    </div>

    <div v-show="objectsWithoutGroupGiven" class="mb-12">
      <h3 class="mb-2">{{ trans('object.withoutGroup') }}</h3>
      <ajax-table
        v-if="canAssignGroup"
        @items-loaded="objectsWithoutGroupGiven = $event.length > 0"
        class="mb-3"
        ref="objectWithoutGroupTable"
        resource="objects/noGroup"
        :headers="[
          {text: 'object.name', value: 'name'},
          {text: 'object.address', value: 'address'},
          {text: 'object.owner', value: 'owner'},
          {text: 'object.group', value: 'group'},
        ]"
        :page-options="{itemsPerPage: 10}"
        :items-per-page-options="[10, 20, 50]"
      >
        <template v-slot:filters>
          <save-button @click="assignObjectGroups" :label="trans('object.assignGroups')"></save-button>
        </template>

        <template v-slot:item.name="{item}">
          <object-name :value="item"/>
        </template>

        <template v-slot:item.address="{item}">
          <div class="subtext">{{ item.street }} {{ item.houseNumber }}</div>
          <div class="subtext">{{ item.zipcode }} {{ item.city }}</div>
          <div class="subtext">{{ item.country }}</div>
        </template>

        <template v-slot:item.owner="{item}">
          <div v-if="item.owner" class="subtext py-2">
            <div>{{ item.owner.fullName }}</div>
            <div>{{ item.owner.address }}</div>
          </div>
        </template>

        <template v-slot:item.group="{item}">
          <select-group :group-id.sync="assignedObjectGroups[item.id]" label=""/>
        </template>

      </ajax-table>
    </div>

    <object-groups-table />

  </v-container>
</template>

<script>
import PageHeading from '../components/PageHeading';
import AjaxTable from '../components/AjaxTable';
import {RouterUtils} from '../utils/router-utils';
import {LocaleUtils} from '../utils/locale-utils';
import SaveButton from '../components/SaveButton';
import {MainUtils} from '../utils/main-utils';
import ObjectName from '@/components/ObjectName';
import SelectGroup from '@/components/SelectGroup';
import {ObjectApi} from '@/api/object-api';
import ObjectGroupsTable from '../components/ObjectGroupsTable';

export default {
  name: 'ObjectAndGroupsPage',
  mixins: [
    MainUtils,
    RouterUtils,
    LocaleUtils
  ],
  components: {
    ObjectGroupsTable,
    SelectGroup,
    ObjectName,
    SaveButton,
    AjaxTable,
    PageHeading
  },
  data: () => ({
    objectsWithoutGroupGiven: false,
    assignedObjectGroups: {},
    exportLoading: false
  }),

  computed: {
    canAssignGroup() {
      return this.hasAnyPermission('OBJECT_GROUP_EDIT');
    },
    pageTitle () {
      return this.transPlural('objectGroup.objectGroup')
    }
  },

  methods: {
    assignObjectGroups() {
      ObjectApi.assignGroups(this.assignedObjectGroups)
        .then(_ => {
          this.$refs.objectWithoutGroupTable.loadData();
        })
    }
  }
}
</script>

<style>

.subtext {
  font-size: 0.9em;
  opacity: 0.8;
}
</style>
